import $http from "superagent";
import { message } from "ant-design-vue";
import { Tacitly } from "./Tacitly";
import clickThrottle from "./timer";
import store from "@/store";
import routes from "../../router/routes.js";
import Router from "vue-router";
import { set } from "core-js/core/dict";
let router = new Router({
  routes,
});
export function ajax({
  url = "", //请求
  data = {}, //data
  type = "post", // 默认post
  contentType = "application/x-www-form-urlencoded",
  hastoken = true,
  head = null,
  updateTime = null,
  success = () => {},
  fail = () => {},
  complete = () => {},
} = parameter) {
  let urlStr = url + JSON.stringify(data) + type, //请求拼接
    fieldurls = [];
  let isContinue = fieldurls.some((v) => {
    return v == urlStr;
  });
  if (isContinue) {
    //拦截重复请求
    return false;
  } else {
    //允许请求
    fieldurls.push(urlStr);
  }
  if (hastoken && !localStorage.getItem("t")) {
    localStorage.clear();
  }
  let p = new Promise((resolve, reject) => {
    let $put;
    let newdata = JSON.parse(JSON.stringify(data));
    if (type == "get") {
      for (const key in newdata) {
        // 去除对象内多余的空值key
        if (
          (!newdata[key] &&
            typeof newdata[key] == "string" &&
            typeof newdata[key] != "number") ||
          newdata[key] === null
        ) {
          delete newdata[key];
        }
      }
    } else {
      if (!clickThrottle()) return;
    }
    (($put = $http
      .delete(Tacitly.Base_Port + url)
      .set("Content-Type", contentType)
      .send(newdata)) &&
      type == "delete") ||
      (($put = $http
        .put(Tacitly.Base_Port + url)
        .set("Content-Type", contentType)
        .send(newdata)) &&
        type == "put") ||
      (($put = $http
        .put(Tacitly.Base_Port + url)
        .set("Content-Type", contentType)) &&
        type == "delete") ||
      (($put = $http
        .get(Tacitly.Base_Port + url)
        .set("Content-Type", contentType)
        .query(newdata)) &&
        type == "get") ||
      (($put = $http
        .post(Tacitly.Base_Port + url)
        .withCredentials()
        .set("Content-Type", contentType)
        .send(newdata)) &&
        type == "post");
    if (hastoken) {
      $put.set({ authorization: localStorage.getItem("t") });
    }
    if (updateTime) {
      $put.set("resubmit-update-time", updateTime);
    }
    $put.end((err, res) => {
      let data = res.body;
      fieldurls.pop(); //请求返回 删去该url
      if (data.code == "0000") {
        success(data.data);
        resolve(data.data);
        if (store.state.updateTime && updateTime) {
          store.dispatch("settime", null);
        }
      } else if (data.code == "1001") {
        //token失效
        message.error(data.msg);
        setTimeout(() => {
          router.push("/login"); //重定向路由到登录页
          window.location.reload(); //刷新页面
        }, 1500);
      } else {
        message.error(data.msg);
        fail(data);
        reject();
      }
    });
  });
  return p;
}
